import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { useChangeSearch, useSearch } from '@btime/react-contexts'
import DropdownLink from '../../../components/navigation/DropdownLink'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import IconButton from '../../../components/actions/IconButton'
import SearchInput from '../../../components/form/SearchInput'
import Separator from '../../../components/helpers/Separator'

const ControlBar = () => {
  const { t } = useTranslation(['common', 'listDynamicServiceOrders'])

  const changeSearch = useChangeSearch()
  const search = useSearch()

  const options = [
    { label: t('views.list'), value: 'list', iconLeft: 'BsListTask' },
    { label: t('listDynamicServiceOrders:cardsView'), disabled: true, value: 'cards', iconLeft: 'BsCardText' }
  ]

  return (
    <Fragment>
      <Separator weight={4} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol>
          <DropdownLink
            actionContent={<IconButton iconLeft="BsListTask" label={t('views.list')} transparent noWrap />}
            options={options}
          />
        </FlexCol>
        <FlexCol flex={3} />
        <FlexCol flex={1}>
          <SearchInput value={search} onStopTyping={changeSearch} />
        </FlexCol>
      </FlexGrid>
      <Separator weight={4} />
    </Fragment>
  )
}

export default ControlBar
